(() => {
  'use strict';
  if (window.__ESHOP_HOME_INIT__) return;
  window.__ESHOP_HOME_INIT__ = true;

  const root = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const currency = () => (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'PKR';
  const locale = () => document.documentElement.lang || 'en-PK';
  const q = (sel, ctx = document) => ctx.querySelector(sel);
  const qa = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));

  function formatMoney(cents) {
    const amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat(locale(), {
        style: 'currency',
        currency: currency(),
        maximumFractionDigits: 0
      }).format(amount);
    } catch (_) {
      return `Rs. ${Math.round(amount).toLocaleString('en-US')}`;
    }
  }

  function predictivePrice(value) {
    if (value === null || value === undefined || value === '') return '';
    if (typeof value === 'number') return formatMoney(Math.round(value * 100));
    const s = String(value).trim();
    if (/^\d+(\.\d+)?$/.test(s)) return formatMoney(Math.round(Number(s) * 100));
    return s;
  }

  let snackbarTimer;
  function snack(message) {
    let el = q('[data-eshop-snackbar]');
    if (!el) {
      el = document.createElement('div');
      el.className = 'eshop-snackbar';
      el.setAttribute('data-eshop-snackbar', '');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-open');
    clearTimeout(snackbarTimer);
    snackbarTimer = setTimeout(() => el.classList.remove('is-open'), 2200);
  }

  function headerRoot() {
    return q('[data-eshop-header-root]');
  }

  function closeOverlays() {
    qa('[data-eshop-panel], [data-eshop-searchbox]').forEach(el => {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    qa('[data-eshop-scrim]').forEach(el => el.classList.remove('is-open'));
    document.documentElement.classList.remove('eshop-body-locked');
    document.body.classList.remove('eshop-body-locked');
  }

  function openOverlay(name) {
    closeOverlays();
    const target = q(`[data-eshop-panel="${name}"]`) || q(`[data-eshop-searchbox="${name}"]`);
    const scrim = q('[data-eshop-scrim]');
    if (!target) return;
    target.classList.add('is-open');
    target.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('is-open');
    document.documentElement.classList.add('eshop-body-locked');
    document.body.classList.add('eshop-body-locked');
    if (name === 'search') {
      window.setTimeout(() => q('[data-eshop-search-input]', target)?.focus(), 120);
    }
  }

  function setButtonBusy(button, busy, busyLabel = 'Adding…') {
    if (!button) return;
    if (busy) {
      button.dataset.eshopOriginalLabel = button.textContent;
      button.textContent = busyLabel;
      button.disabled = true;
    } else {
      button.textContent = button.dataset.eshopOriginalLabel || button.textContent;
      button.disabled = false;
    }
  }

  async function fetchCart() {
    const response = await fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  function updateCartCount(cart) {
    qa('[data-eshop-cart-count]').forEach(el => {
      el.textContent = cart.item_count || 0;
      el.hidden = Number(cart.item_count || 0) === 0;
    });
  }

  function renderCart(cart) {
    updateCartCount(cart);
    const body = q('[data-eshop-cart-body]');
    const foot = q('[data-eshop-cart-foot]');
    const header = headerRoot();
    if (!body || !foot || !header) return;

    const thresholdMajor = Number(header.dataset.freeShipping || 0);
    const threshold = thresholdMajor * 100;
    const flatShippingMajor = Number(header.dataset.shippingFee || 0);
    const flatShipping = flatShippingMajor * 100;

    if (!cart.items || !cart.items.length) {
      body.innerHTML = `<div class="eshop-cart-empty"><strong>Your cart is empty</strong><p>Add a product and it will appear here.</p><button type="button" class="eshop-btn eshop-btn-out eshop-btn-sm" style="margin-top:20px" data-eshop-close>Continue shopping</button></div>`;
      foot.hidden = true;
      return;
    }

    foot.hidden = false;
    const remaining = threshold > 0 ? Math.max(0, threshold - cart.total_price) : 0;
    const shipLine = threshold > 0
      ? `<p class="eshop-ship-line">${remaining > 0 ? `Add ${escapeHtml(formatMoney(remaining))} more for free delivery.` : 'Delivery is free on this order.'}</p>`
      : '';

    body.innerHTML = shipLine + cart.items.map(item => {
      const image = item.image || item.featured_image?.url || '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      return `<div class="eshop-cart-item">
        ${image ? `<a href="${escapeHtml(item.url)}"><img src="${escapeHtml(image)}" alt="" loading="lazy"></a>` : '<div></div>'}
        <div>
          <h4><a href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a></h4>
          ${variant ? `<div class="eshop-cart-meta">${escapeHtml(variant)}</div>` : ''}
          <div class="eshop-cart-row">
            <div class="eshop-qty">
              <button type="button" data-eshop-change="${escapeHtml(item.key)}" data-quantity="${Math.max(0,item.quantity-1)}" aria-label="Decrease quantity">−</button>
              <span>${item.quantity}</span>
              <button type="button" data-eshop-change="${escapeHtml(item.key)}" data-quantity="${item.quantity+1}" aria-label="Increase quantity">+</button>
            </div>
            <strong>${escapeHtml(formatMoney(item.final_line_price))}</strong>
          </div>
          <button type="button" class="eshop-remove" data-eshop-change="${escapeHtml(item.key)}" data-quantity="0">Remove</button>
        </div>
      </div>`;
    }).join('');

    const qualifiesFree = threshold > 0 && cart.total_price >= threshold;
    const shipping = qualifiesFree ? 0 : flatShipping;
    const estimated = cart.total_price + shipping;
    q('[data-eshop-cart-subtotal]', foot).textContent = formatMoney(cart.total_price);
    q('[data-eshop-cart-shipping]', foot).textContent = qualifiesFree ? 'Free' : (flatShipping > 0 ? formatMoney(flatShipping) : 'At checkout');
    q('[data-eshop-cart-total]', foot).textContent = flatShipping > 0 || qualifiesFree ? formatMoney(estimated) : formatMoney(cart.total_price);
  }

  async function syncCart() {
    try {
      renderCart(await fetchCart());
    } catch (error) {
      console.warn('[E-Shopping] Cart sync failed:', error);
    }
  }

  async function addVariant(variantId, button) {
    if (!variantId) return;
    setButtonBusy(button, true);
    try {
      const response = await fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || 'Could not add this item');
      await syncCart();
      snack('Added to your cart');
      if (q('[data-eshop-panel="cart"]')) openOverlay('cart');
    } catch (error) {
      snack(error.message || 'Could not add this item');
    } finally {
      setButtonBusy(button, false);
    }
  }

  async function changeLine(key, quantity, button) {
    if (!key) return;
    if (button) button.disabled = true;
    try {
      const response = await fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: Number(quantity) })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || 'Could not update cart');
      renderCart(cart);
    } catch (error) {
      snack(error.message || 'Could not update cart');
      syncCart();
    } finally {
      if (button) button.disabled = false;
    }
  }

  function activateTab(button) {
    const tabs = button.closest('[data-eshop-tabs]');
    if (!tabs) return;
    const key = button.dataset.eshopTab;
    qa('[data-eshop-tab]', tabs).forEach(btn => {
      const active = btn === button;
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
      btn.tabIndex = active ? 0 : -1;
    });
    qa('[data-eshop-panel-key]', tabs).forEach(panel => {
      panel.hidden = panel.dataset.eshopPanelKey !== key;
    });
  }

  let searchTimer;
  async function runPredictiveSearch(input) {
    const box = input.closest('[data-eshop-searchbox]');
    const results = q('[data-eshop-search-results]', box);
    if (!results) return;
    const term = input.value.trim();
    if (!term) {
      results.innerHTML = '<p class="eshop-search-none">Try 20W, Lightning cable, Samsung, or bundle.</p>';
      return;
    }

    results.innerHTML = '<p class="eshop-search-none">Searching…</p>';
    try {
      const params = new URLSearchParams();
      params.set('q', term);
      params.set('resources[type]', 'product');
      params.set('resources[limit]', '6');
      params.set('resources[options][unavailable_products]', 'hide');
      const response = await fetch(root() + 'search/suggest.json?' + params.toString(), { headers: { Accept: 'application/json' } });
      const data = await response.json();
      const products = data?.resources?.results?.products || [];
      if (!products.length) {
        const whatsapp = headerRoot()?.dataset.whatsappUrl || '#';
        results.innerHTML = `<p class="eshop-search-none">Nothing matched that. <a href="${escapeHtml(whatsapp)}" style="text-decoration:underline;color:var(--eshop-bronze-dark)">Ask us on WhatsApp</a>.</p>`;
        return;
      }
      results.innerHTML = products.map(p => {
        const image = p.image || p.featured_image?.url || '';
        const price = predictivePrice(p.price);
        return `<a class="eshop-search-result" href="${escapeHtml(p.url)}">
          ${image ? `<img src="${escapeHtml(image)}" alt="" loading="lazy">` : '<span></span>'}
          <div><h4>${escapeHtml(p.title)}</h4><em>${escapeHtml(p.type || p.product_type || '')}</em></div>
          ${price ? `<b>${escapeHtml(price)}</b>` : ''}
        </a>`;
      }).join('');
    } catch (error) {
      results.innerHTML = '<p class="eshop-search-none">Search is temporarily unavailable. Please try again.</p>';
    }
  }

  document.addEventListener('click', event => {
    const add = event.target.closest('[data-eshop-add]');
    if (add) {
      event.preventDefault();
      addVariant(add.dataset.eshopAdd, add);
      return;
    }

    const change = event.target.closest('[data-eshop-change]');
    if (change) {
      event.preventDefault();
      changeLine(change.dataset.eshopChange, change.dataset.quantity, change);
      return;
    }

    const opener = event.target.closest('[data-eshop-open]');
    if (opener) {
      event.preventDefault();
      openOverlay(opener.dataset.eshopOpen);
      return;
    }

    if (event.target.closest('[data-eshop-close]') || event.target.closest('[data-eshop-scrim]')) {
      event.preventDefault();
      closeOverlays();
      return;
    }


    const jump = event.target.closest('[data-eshop-jump]');
    if (jump) {
      const key = jump.dataset.eshopJump;
      const tabsRoot = q('[data-eshop-tabs]');
      const targetTab = tabsRoot ? q(`[data-eshop-tab="${CSS.escape(key)}"]`, tabsRoot) : null;
      if (targetTab) {
        event.preventDefault();
        activateTab(targetTab);
        tabsRoot.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        history.replaceState(null, '', '#products');
        return;
      }
    }

    const tab = event.target.closest('[data-eshop-tab]');
    if (tab) {
      event.preventDefault();
      activateTab(tab);
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') closeOverlays();
    const tab = event.target.closest?.('[data-eshop-tab]');
    if (!tab || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
    const tabs = qa('[data-eshop-tab]', tab.closest('[data-eshop-tabs]'));
    const index = tabs.indexOf(tab);
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
    if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
    if (event.key === 'Home') next = 0;
    if (event.key === 'End') next = tabs.length - 1;
    event.preventDefault();
    tabs[next]?.focus();
    activateTab(tabs[next]);
  });

  document.addEventListener('input', event => {
    const input = event.target.closest?.('[data-eshop-search-input]');
    if (!input) return;
    clearTimeout(searchTimer);
    searchTimer = setTimeout(() => runPredictiveSearch(input), 220);
  });

  document.addEventListener('shopify:section:load', () => syncCart());
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncCart, { once: true });
  } else {
    syncCart();
  }
})();
